import { createSlice } from "@reduxjs/toolkit";
import * as action from "../actions/canadaNowActions";

export const canadaNowSlicer = createSlice({
  name: "canadaNow",
  initialState: {
    loading: false,
    news: null,
    events: null,
    communityEvents: [],
    stocks: null,
    error: null,
  },
  extraReducers: {
    [action.fetchLatestNews.pending]: (state) => {
      state.loading = true;
    },
    [action.fetchLatestNews.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.news = data;
      } else {
        state.error = data;
      }
      state.loading = false;
    },
    [action.fetchLatestNews.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // Events
    [action.fetchEvents.pending]: (state) => {
      state.loading = true;
    },
    [action.fetchEvents.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.events = data;
      } else {
        state.error = data;
      }
      state.loading = false;
    },
    [action.fetchEvents.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [action.fetchStocks.pending]: (state) => {
      state.loading = true;
    },
    [action.fetchStocks.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.stocks = data;
      } else {
        state.error = data;
      }
      state.loading = false;
    },
    [action.fetchStocks.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    [action.fetchCommunityEvents.pending]: (state) => {
      state.loading = true;
    },
    [action.fetchCommunityEvents.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.communityEvents = data;
      } else {
        state.error = data;
      }
      state.loading = false;
    },
    [action.fetchCommunityEvents.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // Inside extraReducers:
    [action.addCommunityEvent.pending]: (state) => {
      state.loading = true;
    },
    [action.addCommunityEvent.rejected]: (state, action) => {
      state.loading = false;
      // action.payload now contains the data passed to rejectWithValue
      state.error = action.payload;
    },
    [action.addCommunityEvent.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 201 || status === 200) {
        // Add the new event to the top of the list
        state.communityEvents = [data, ...state.communityEvents];
      } else {
        state.error = data;
      }
      state.loading = false;
    },
    // reducers/canadaNowSlicer.js
    [action.removeCommunityEvent.fulfilled]: (state, action) => {
      const { status, eventId } = action.payload;
      if (status === 200 || status === 204) {
        state.communityEvents = state.communityEvents.filter(
          (event) => event._id !== eventId,
        );
      } else {
        state.error = "Failed to delete";
      }
      state.loading = false;
    },
  },
});

export default canadaNowSlicer.reducer;
